export function parseDate(date) {
  if (date) {
    var full_date_arr = date.split(' ');
    var date_arr = full_date_arr[0].split('-');
    return parseInt(date_arr[2]) + '. ' + parseInt(date_arr[1]) + '. ' + parseInt(date_arr[0]);
  }

  return '';
}
